import { ProjectSubType, ProjectType, ProjectSelector } from "@ecologi/shared";
import {
  carbonAvoidanceSubTypeVisuals,
  carbonAvoidanceVisuals,
} from "./carbon-avoidance-visuals";
import { reforestationVisuals } from "./reforestation-visuals";
import { carbonRemovalVisuals } from "./carbon-removal-visuals";
import { marineVisuals } from "./marine-visuals";
import { habitatRestorationVisuals } from "./habitat-restoration-visuals";

export type ProjectVisualsType = {
  icon: JSX.Element;
  pictogram: string;
  tileImage?: string;
};

export const projectTypeVisuals: Record<
  Exclude<ProjectType, ProjectSelector>,
  ProjectVisualsType
> = {
  ...reforestationVisuals,
  ...carbonAvoidanceVisuals,
  ...carbonRemovalVisuals,
  ...habitatRestorationVisuals,
  ...marineVisuals,
};

export const projectSubTypeVisuals: Record<
  Exclude<ProjectSubType, ProjectSelector>,
  ProjectVisualsType
> = {
  ...carbonAvoidanceSubTypeVisuals,
};
